/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

// vue related stuff
require("../../js/app");

$(window).scrollTop(0);
/**
 * Now we can write our custom code
 */

/**
 * Init Foundation
 */
$(document).foundation();

/**
 * Scroll Reveal
 */
sr.reveal("[data-scrollreveal]", { duration: 1000 });

// /**
//  * Toggle Header Search bar
//  */
// $(document).on("click", "[data-toggle-search-trigger]", function(e) {
//     e.preventDefault();
//     $("[data-toggle-search]").slideToggle(400, function() {
//         $("[data-toggle-search]").find("[name='keywords']:visible").focus();
//     });
// });


$(document).on("change", ".language-select", function(e) {
    $(this).parents('.language-select-form').submit();
});

$(document).ready(function () {
    var header = $(".main-navigation-wrap");

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 5) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    });
});

// respect menu height on smooth scroll
$(document).ready(function() {
    var menuHeight = 130;

    $('.blog a[href^="#"]').click(function() {
        var target = $(this.hash);

        if (target.length == 0) {
            target = $('a[name="' + this.hash.substr(1) + '"]');
        }

        if (target.length == 0) {
            target = $('html');
        }

        $('html, body').scrollTop(target.offset().top - menuHeight);

        return false;
    });
});

// megamenu temp
require("./megamenu");
// pardot forms
require("./pardot-forms");
// resources filters
require("./resources");
// stock check
require("./stock-check");
